// ─────────────────────────────────────────────
//  SERVICES DATA
//  Edit this file to update the Services section.
//  Each object = one service card on the website.
// ─────────────────────────────────────────────

const services = [
  {
    id: 1,
    title: 'Systems Integration',
    description:
      'Seamlessly connecting BMS, BAS, and EPMS platforms into a unified operational layer — reducing silos and improving visibility across your entire facility.',
    icon: 'integration',
  },
  {
    id: 2,
    title: 'Building Automation',
    description:
      'Design, implementation, and optimization of BAS and BMS solutions for commercial and critical facility environments, including HVAC, lighting, and access control integration.',
    icon: 'building',
  },
  {
    id: 3,
    title: 'EPMS Consulting',
    description:
      'Expert consulting for Electrical Power Management Systems — from UPS monitoring and PDU integration to generator controls and power analytics dashboards.',
    icon: 'power',
  },
  {
    id: 4,
    title: 'Data Center Solutions',
    description:
      'Specialized integration services for data centers — including DCIM integration, environmental monitoring, cooling control optimization, and critical power oversight.',
    icon: 'datacenter',
  },
  {
    id: 5,
    title: 'Project Commissioning',
    description:
      'End-to-end commissioning support ensuring your integrated systems perform as designed — including functional testing, documentation, and operator training.',
    icon: 'commissioning',
  },
  {
    id: 6,
    title: 'Ongoing Support',
    description:
      'Post-commissioning support, system monitoring, performance reporting, and optimization services to keep your facility\'s automation ecosystem running at peak efficiency.',
    icon: 'support',
  },
];

export default services;
